<script>
export default
{
    name: 'fake-status-bar',

    created ()
    {
    },

    render () 
    {
        return (
            <div id='fake-status-bar' style={{ background: this.isVisible ? 'var(--theme-status-bar-background-color)' : 'transparent' }} />
        )
    },

    data () 
    {
        return {
            isVisible: true
        }
    },

    mounted ()
    {
        this.$router.afterEach((to, from) =>
        {
            this.isVisible = to.meta.hideStatusBar ? false : true
        })
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#fake-status-bar
{
    width: 100%;
    height: var(--theme-status-bar-height);
    margin-bottom: - var(--theme-status-bar-height);
    position: fixed;
    z-index: 3;
    top: 0;
    
    .OnDesktop({
        display: none;
    });
}
</style>


// WEBPACK FOOTER //
// src/components/FakeStatusBar.vue